import {
  GetUserResponse,
  getUser,
  UpdateUserResponse,
  updateUser,
  UpdateUserPayload,
  UploadFileUserResponse,
  uploadFileUser,
  getRegistryFileUser,
  UpdateUserEmailPayload,
  updateUserEmail,
} from 'app/api/user'
import { getAuthFromLocalStorage } from 'app/contexts/AuthenticationProvider/persistAuthToken'
import { AxiosError } from 'axios'
import { ApiError } from 'EstraSponsor'
import {
  UseQueryResult,
  UseMutationResult,
  useMutation,
  useQueryClient,
  useQuery,
} from 'react-query'

export const useGetUser = (): UseQueryResult<
  GetUserResponse | null,
  AxiosError<ApiError>
> => {
  return useQuery('user', async () => {
    return getAuthFromLocalStorage() ? getUser() : null
  })
}

export const useUpdateUser = (): UseMutationResult<
  UpdateUserResponse,
  AxiosError<ApiError>,
  UpdateUserPayload
> => {
  const queryClient = useQueryClient()
  return useMutation(updateUser, {
    onSuccess: (data) => {
      queryClient.setQueryData('user', data)
    },
  })
}

export const useUploadFileUser = (): UseMutationResult<
  UploadFileUserResponse,
  AxiosError<ApiError>,
  FormData
> => {
  const queryClient = useQueryClient()
  return useMutation(uploadFileUser, {
    onSuccess: () => {
      queryClient.invalidateQueries('user')
    },
  })
}

type UseGetRegistryFileUser = {
  executeOnStart?: boolean
  onSuccess?: (data: File) => void
}

export const useGetRegistryFileUser = ({
  executeOnStart,
  onSuccess,
}: UseGetRegistryFileUser = {}): UseQueryResult<File, AxiosError<ApiError>> => {
  return useQuery('user_registry_file', getRegistryFileUser, {
    enabled: executeOnStart,
    onSuccess: (data) => {
      if (onSuccess) onSuccess(data)
    },
  })
}

export const useUpdateUserEmail = (): UseMutationResult<
  void,
  AxiosError<ApiError>,
  UpdateUserEmailPayload
> => {
  const queryClient = useQueryClient()
  return useMutation(updateUserEmail, {
    onSuccess: () => {
      queryClient.invalidateQueries('user')
    },
  })
}
